import PropTypes from 'prop-types'
import React from 'react'
import HeroVideo from '../components/hero-video'

const BrandPartnerships = ({
  desktopPosterSrc,
  mobilePosterSrc,
  desktopVideoSrc,
  mobileVideoSrc
}) => (
  <div className='brand-partnerships'>
    <div className='brand-partnerships__video'>
      <HeroVideo
        desktopPosterSrc={desktopPosterSrc}
        mobilePosterSrc={mobilePosterSrc}
        desktopVideoSrc={desktopVideoSrc}
        mobileVideoSrc={mobileVideoSrc}
      />
    </div>
    <div className='brand-partnerships__info'>
      <span className='brand-partnerships__eyebrow'>
        Brand partnerships
      </span>
      <h2 className='brand-partnerships__header'>
        Where purpose<br />meets performance
      </h2>
      <p className='brand-partnerships__description'>
        We partner with brands who stand for something — giving them an
        editorial "in" with our audience of socially&#8209;conscious doers
        and deciders.
      </p>
    </div>
  </div>
)

BrandPartnerships.propTypes = {
  desktopPosterSrc: PropTypes.string,
  mobilePosterSrc: PropTypes.string,
  desktopVideoSrc: PropTypes.string,
  mobileVideoSrc: PropTypes.string
}

export default BrandPartnerships



// WEBPACK FOOTER //
// ./src/components/brand-partnerships.js